import React from 'react';
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuItem,
  SidebarSeparator,
} from '~/lib/ui/sidebar';
import { ContactDetailsNotesProps } from './index.types';

export const ContactDetailsNotes = ({
  contact,
  showSeparator,
}: ContactDetailsNotesProps) => {
  return (
    <>
      {showSeparator && (
        <div className="px-3.5">
          <SidebarSeparator />
        </div>
      )}
      <SidebarGroup className="px-[7px]">
        <SidebarGroupLabel>Notes</SidebarGroupLabel>
        <SidebarMenu className="px-0">
          <SidebarMenuItem className="px-2 flex gap-2 break-word">
            {contact.notes}
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroup>
    </>
  );
};
